import { render } from "./2025.vue?vue&type=template&id=831b43bc"
import script from "./2025.vue?vue&type=script&lang=js"
export * from "./2025.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__